import { LInputField } from "@components";
import { searchUpcomingAssessmentsFilter } from "@fadmin/tabs/results/components/filterHelper";
import { UpcomingAssessment } from "@store/locationsSlice";
import { ChangeEvent, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { RightSide } from "../right-side/RightSide";
import { LeftSide } from "./LeftSide";

export const CompletedAssessments = ({ assessments, onClick }: CompletedAssessmentsProps): JSX.Element => {
    const validateMethods = useForm();

    const [selectedUpcomingAssessment, setSelectedUpcomingAssessment] = useState<UpcomingAssessment>();
    const [searchValue, setSearchValue] = useState("");

    const handleSelectExaminee = (upcomingAssessment: UpcomingAssessment): void => {
        setSelectedUpcomingAssessment(upcomingAssessment);
    };

    const handleSearch = (e: ChangeEvent<HTMLInputElement>): void => {
        setSearchValue(e.target.value);
    };

    const filteredExaminees = searchUpcomingAssessmentsFilter(searchValue, assessments);

    return (
        <div>
            <div className="is-flex is-justify-content-space-between is-align-items-center mb-5">
                <div className="mx-6 minw-40">
                    <FormProvider {...validateMethods}>
                        <LInputField
                            inputName="search"
                            placeholder="Search examinees"
                            isSearch={true}
                            onChange={handleSearch}
                            isExpanded
                            isRounded
                            hideErrorLabel
                        />
                    </FormProvider>
                </div>
                <div />
            </div>
            <div className="columns">
                <LeftSide assessments={filteredExaminees} handleSelectExaminee={handleSelectExaminee} />
                <RightSide upcomingAssessment={selectedUpcomingAssessment} completed />
            </div>
        </div>
    );
};

interface CompletedAssessmentsProps {
    assessments: UpcomingAssessment[];
    onClick: () => void;
}
